import {
    initMobileView, initMobileOfferForm, initPaycodeForm
} from './initValues';

/**
 * @template T
 * @typedef {{ type: string; payload: T }} ReducerAction
 */

export const mobileViewReducer = (view = initMobileView, action) => {
    if (action.type === 'UPDATE_MOBILE_VIEW') {
        return Object.assign({}, {
            previous: view.current,
            current: action.payload
        })
    }
    return view
}

export const mobileOfferShiftFormReducer = (form = initMobileOfferForm, action) => {
    if (action.type === 'UPDATE_OFFER_FORM') {
        return Object.assign({}, form, action.payload)
    } else if (action.type === 'CLEAR_OFFER_FORM') {
        return Object.assign({}, initMobileOfferForm)
    }
    else {
        return form
    }
}

export const mobileProposalShiftsReducer = (shifts = [], action) => {
    if (action.type === 'UPDATE_PROPOSAL_SHIFTS_SELECTED') {
        return Object.assign([], action.payload)
    }
    else if (action.type === 'CLEAR_OFFER_FORM' || action.type === 'CLOSE_SIDE_PANEL') {
        return [];
    }
    else {
        return shifts
    }
}

/**
 * @typedef {{ title: string; duration: string }} PaycodeFormPayload
 * @param {ReducerAction<PaycodeFormPayload>} action
 * @param {any} initPaycodeForm
 */
export const mobilePaycodeFormReducer = (paycodeForm = initPaycodeForm, action) =>
    action?.type === "UPDATE_PAYCODE_FORM"
        ? Object.assign({}, paycodeForm, { paycode: action?.payload })
        : paycodeForm;
